var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgProcessingIcon = function SvgProcessingIcon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 60 60",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clock-icon"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFAD00",
    cx: 30,
    cy: 30,
    r: 30
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,30 L30,24.4444444",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 5.33333333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,45.5555556 C38.5911111,45.5555556 45.5555556,38.5911111 45.5555556,30 C45.5555556,21.4088889 38.5911111,14.4444444 30,14.4444444 C21.4088889,14.4444444 14.4444444,21.4088889 14.4444444,30 C14.4444444,38.5911111 21.4088889,45.5555556 30,45.5555556 Z",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 5.33333333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,30 L35.3333333,35.3333333",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 5.33333333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProcessingIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/processing-icon.7a310ac9.svg";
export { ForwardRef as ReactComponent };